
import { mapActions, mapState } from 'vuex';
import RetirementCalculatorInput from '@/ui/retirement-calculator/retirement-calculator-input.vue';
import { YES_NO_OPTIONS } from '@/utils/common-constants';

export default {
  name: 'HousingForm',

  components: {
    RetirementCalculatorInput,
  },

  props: {
    isOnMobile: {
      default: true,
      type: Boolean,
    },
  },

  data: () => ({
    isPartnerIncomeDisabled: false,
  }),

  computed: {
    ...mapState({
      homeOwnership: (state) =>
        state['pension-calculator'].inputs.boolean_home_owner,
      regions: ({ regions }) => regions.regionOptions,
    }),

    homeOwnershipOptions() {
      return Object.entries(this.$t('homeOwnership.options')).map(
        ([value, text]) => ({ value, text }),
      );
    },
    isHomeOwner() {
      return this.homeOwnership === YES_NO_OPTIONS.yes;
    },
  },

  mounted() {
    this.fetchRegionOptions({ locale: this.$i18n.locale });
  },

  methods: {
    ...mapActions({ fetchRegionOptions: 'regions/fetchRegionOptions' }),
  },
};
